import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type ListNameFragment = (
  { __typename: 'List' }
  & Pick<Types.List, 'id' | 'name'>
);

export const ListNameFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ListName' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'List' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseListNameFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<ListNameFragment, Apollo.OperationVariables>,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseListNameFragmentResult
  extends Omit<Apollo.UseFragmentResult<ListNameFragment>, 'data'> {
  data?: ListNameFragment;
}

export const useListNameFragment = ({
  from,
  returnPartialData,
  ...options
}: UseListNameFragmentOptions): UseListNameFragmentResult => {
  const result = Apollo.useFragment<ListNameFragment>({
    ...options,
    fragment: ListNameFragmentDoc,
    fragmentName: 'ListName',
    from: {
      __typename: 'List',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('Fragment data is incomplete.', result);
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return { ...result, data: result.data as ListNameFragment };
};
